import { Navigate } from "@/components/_molecules/navigation-controls/navigate";
import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";

const TeamLayout = lazyRoute(() => import("./app/$teamId/team.layout"), "TeamLayout");
const TeamPage = lazyRoute(() => import("./app/$teamId/team.page"), "TeamPage");
const TeamClimateActionListAllPage = lazyRoute(() => import("./app/$teamId/team-climate-actions/(list)/team-climate-action-list.all.page"), "TeamClimateActionListAllPage");
const TeamClimateActionListBoardPage = lazyRoute(() => import("./app/$teamId/team-climate-actions/(list)/team-climate-action-list-board.page"), "TeamClimateActionListBoardPage");
const TeamClimateActionListDashboardPage = lazyRoute(() => import("./app/$teamId/team-climate-actions/(list)/team-climate-action-list.dashboard.page"), "TeamClimateActionListDashboardPage");
const TeamClimateActionListLayout = lazyRoute(() => import("./app/$teamId/team-climate-actions/(list)/team-climate-action-list.layout"), "TeamClimateActionListLayout");
const TeamClimateActionListTimelinePage = lazyRoute(() => import("./app/$teamId/team-climate-actions/(list)/team-climate-action-list-timeline.page"), "TeamClimateActionListTimelinePage");
const TeamClimateActionTrashPage = lazyRoute(() => import("./app/$teamId/team-climate-actions/(list)/team-climate-action-trash.page"), "TeamClimateActionTrashPage");
const SharedClimateActionListLayout = lazyRoute(() => import("./app/shared-teams/shared-climate-action-list.layout"), "SharedClimateActionListLayout");
const SharedProjectListLayout = lazyRoute(() => import("./app/shared-teams/shared-project-list.layout"), "SharedProjectListLayout");
const SharedTaskListLayout = lazyRoute(() => import("./app/shared-teams/shared-task-list.layout"), "SharedTaskListLayout");
const SharedTeamLayout = lazyRoute(() => import("./app/shared-teams/shared-team.layout"), "SharedTeamLayout");
const TaskListLayout = lazyRoute(() => import("./app/task-list/task-list.layout"), "TaskListLayout");
const TeamTaskListPage = lazyRoute(() => import("./app/task-list/task-list.page"), "TeamTaskListPage");
const TeamTaskListBoardPage = lazyRoute(() => import("./app/task-list/task-list-board.page"), "TeamTaskListBoardPage");
const TeamTaskTrashPage = lazyRoute(() => import("./app/task-list/team-task-trash.page"), "TeamTaskTrashPage");
const TeamListLayout = lazyRoute(() => import("./app/team-list.layout"), "TeamListLayout");
const TeamListPage = lazyRoute(() => import("./app/team-list.page"), "TeamListPage");
const TeamProjectListAllPage = lazyRoute(() => import("./app/team-project/(list)/project-list.all.page"), "TeamProjectListAllPage");
const TeamProjectListBoardPage = lazyRoute(() => import("./app/team-project/(list)/project-list-board.page"), "TeamProjectListBoardPage");
const TeamProjectListDashboardPage = lazyRoute(() => import("./app/team-project/(list)/project-list.dashboard.page"), "TeamProjectListDashboardPage");
const TeamProjectListLayout = lazyRoute(() => import("./app/team-project/(list)/project-list.layout"), "TeamProjectListLayout");
const TeamProjectListTimelinePage = lazyRoute(() => import("./app/team-project/(list)/project-list-timeline.page"), "TeamProjectListTimelinePage");
const TeamProjectTrashPage = lazyRoute(() => import("./app/team-project/(list)/team-project-trash.page"), "TeamProjectTrashPage");
const TeamCreatePage = lazyRoute(() => import("./settings/team-create.page"), "TeamCreatePage");
const TeamListSettingsLayout = lazyRoute(() => import("./settings/team-list-settings.layout"), "TeamListSettingsLayout");
const TeamListSettingsPage = lazyRoute(() => import("./settings/team-list-settings.page"), "TeamListSettingsPage");
const TeamManagementPage = lazyRoute(() => import("./settings/team-management.page"), "TeamManagementPage");
const TeamSettingsLayout = lazyRoute(() => import("./settings/team-settings.layout"), "TeamSettingsLayout");
const TeamSettingsGeneralPage = lazyRoute(() => import("./settings/team-settings-general.page"), "TeamSettingsGeneralPage");
const TeamSettingsMembershipPage = lazyRoute(() => import("./settings/team-settings-membership.page"), "TeamSettingsMembershipPage");

export const teamRoutes = [
  {
    path: "teams",
    element: <TeamListLayout />,
    children: [
      { path: "", element: <TeamListPage /> },
      {
        path: ":teamId",
        element: <TeamLayout />,
        children: [
          { path: "", element: <TeamPage /> },
          {
            path: "climate-actions",
            element: <TeamClimateActionListLayout />,
            children: [
              { path: "", element: <Navigate to="all" replace /> },
              { path: "all", element: <TeamClimateActionListAllPage /> },
              { path: "dashboard", element: <TeamClimateActionListDashboardPage /> },
              {
                path: "board",
                element: (
                  <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to="all" replace />}>
                    <TeamClimateActionListBoardPage />
                  </FeatureFlagToggle>
                ),
              },
              {
                path: "timeline",
                element: (
                  <FeatureFlagToggle flag="enable-timeline-tab" fallback={<Navigate to="all" replace />}>
                    <TeamClimateActionListTimelinePage />
                  </FeatureFlagToggle>
                ),
              },
              { path: "trash", element: <TeamClimateActionTrashPage /> },
            ],
          },
          {
            path: "projects",
            element: <TeamProjectListLayout />,
            children: [
              { path: "", element: <Navigate to="all" replace /> },
              { path: "all", element: <TeamProjectListAllPage /> },
              { path: "dashboard", element: <TeamProjectListDashboardPage /> },
              {
                path: "board",
                element: (
                  <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to="all" replace />}>
                    <TeamProjectListBoardPage />
                  </FeatureFlagToggle>
                ),
              },
              {
                path: "timeline",
                element: (
                  <FeatureFlagToggle flag="enable-timeline-tab" fallback={<Navigate to="all" replace />}>
                    <TeamProjectListTimelinePage />
                  </FeatureFlagToggle>
                ),
              },
              { path: "trash", element: <TeamProjectTrashPage /> },
            ],
          },
          {
            path: "tasks",
            element: <TaskListLayout />,
            children: [
              { path: "", element: <Navigate to="all" replace /> },
              { path: "all", element: <TeamTaskListPage /> },
              {
                path: "board",
                element: (
                  <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to="all" replace />}>
                    <TeamTaskListBoardPage />
                  </FeatureFlagToggle>
                ),
              },
              { path: "trash", element: <TeamTaskTrashPage /> },
            ],
          },
        ],
      },
    ],
  },
];

export const sharedTeamRoutes = [
  {
    path: "shared-teams/:teamId",
    element: <SharedTeamLayout />,
    children: [
      { path: "", element: <Navigate to="climate-actions" replace /> },
      {
        path: "climate-actions",
        element: <SharedClimateActionListLayout />,
        children: [
          { path: "", element: <Navigate to="all" replace /> },
          { path: "all", element: <TeamClimateActionListAllPage /> },
          { path: "dashboard", element: <TeamClimateActionListDashboardPage /> },
          {
            path: "board",
            element: (
              <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to="all" replace />}>
                <TeamClimateActionListBoardPage />
              </FeatureFlagToggle>
            ),
          },
          {
            path: "timeline",
            element: (
              <FeatureFlagToggle flag="enable-timeline-tab" fallback={<Navigate to="all" replace />}>
                <TeamClimateActionListTimelinePage />
              </FeatureFlagToggle>
            ),
          },
        ],
      },
      {
        path: "projects",
        element: <SharedProjectListLayout />,
        children: [
          { path: "", element: <Navigate to="all" replace /> },
          { path: "all", element: <TeamProjectListAllPage /> },
          { path: "dashboard", element: <TeamProjectListDashboardPage /> },
          {
            path: "board",
            element: (
              <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to="all" replace />}>
                <TeamProjectListBoardPage />
              </FeatureFlagToggle>
            ),
          },
          {
            path: "timeline",
            element: (
              <FeatureFlagToggle flag="enable-timeline-tab" fallback={<Navigate to="all" replace />}>
                <TeamProjectListTimelinePage />
              </FeatureFlagToggle>
            ),
          },
        ],
      },
      {
        path: "tasks",
        element: <SharedTaskListLayout />,
        children: [
          { path: "", element: <Navigate to="all" replace /> },
          { path: "all", element: <TeamTaskListPage /> },
          {
            path: "board",
            element: (
              <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to="all" replace />}>
                <TeamTaskListBoardPage />
              </FeatureFlagToggle>
            ),
          },
        ],
      },
    ],
  },
];

export const workspaceTeamSettingsRoutes = [
  {
    path: "new-team",
    element: <TeamCreatePage />,
  },
  {
    path: "team-management",
    element: <TeamManagementPage />,
  },
];

export const teamSettingsRoutes = [
  {
    path: "teams",
    element: <TeamListSettingsLayout />,
    children: [
      { path: "", element: <TeamListSettingsPage /> },
      {
        path: ":teamId",
        element: <TeamSettingsLayout />,
        children: [
          { path: "", element: <Navigate to="general" replace /> },
          { path: "general", element: <TeamSettingsGeneralPage /> },
          { path: "members", element: <TeamSettingsMembershipPage /> },
        ],
      },
    ],
  },
];
